<template>
<div class="freeboard-comments--inner">
  <h3> Comments </h3>
  <div class="post-comments-wrap">
    <div
      v-for="comment in comments" :key="comment.id"
      class="post-comment-item"
      v-if="comments.length"
    >
      <div class="post-comment-head">
        <div class="login-name">
          <div v-if="comment.user">
            <span v-if="comment.user.isTester">Test User: </span>
            <span v-if="!comment.user.isTester">user:</span>
            <span>{{ comment.user.login_name }}</span>
          </div>

          <div v-if="comment.admin">
            <span>ADMIN:</span>
            <span>{{ comment.admin.login_id }}</span>
          </div>
        </div>
        <div class="date">reply date: {{ comment.created_at | date }} </div>
      </div>

      <div class="post-comment-content"> {{comment.content}} </div> <!--post-comment-content-->
    </div>
    <div v-if="!comments.length"> No comments </div>
  </div>

  <div class="post-comments-input">

    <div class="post-details -user">
      <div class="post-items -post-as"> <!-- .-post-as -->
        <div class="post-items--lbl">
          <span>post as</span>
        </div>

        <div class="post-items--data">
          <select-list
            title="post as"
            :withReset="true"
            v-model="postAs"
          >
            <select-option
              value="test"
              name="test user"
            >
              test user
            </select-option>
            <select-option
              value="user"
              name="user"
            >
              user
            </select-option>
          </select-list>
        </div>
      </div> <!-- .-post-as -->

      <div class="post-items -login-name"> <!-- .-login-name -->
        <div class="post-items--lbl">
          <span>login name</span>
        </div>

        <div class="post-items--data">
          <input-suggestion
            @search="searchUsers"
            v-model="userId"
            placeholder="user"
          >
            <div slot="selected">
              {{ postUser }}
            </div>
            <suggestion slot="suggestion" :key="user.id" v-for="user in userList" :value="user.id">
              {{ user.login_id }}
            </suggestion>
          </input-suggestion>
        </div>
      </div> <!-- .-login-name -->
    </div>

    <div class="textarea-wrap">
      <text-area
        v-model="comment"
        :content="comment"
      >
    </text-area>
  </div>
  </div>

  <div
    class="post-comments-buttons"
    v-if="data.id"
  >
    <button
      class="btn--comment -withlabel -right"
      @click="addComment()"
    >
      <i class="ico--send"></i>
      <span>comment</span>
    </button>
  </div>
</div>
</template>
<script type="text/javascript">
import { mapGetters, mapActions, mapState } from 'vuex'

import TextArea from '@/components/base/TextArea'

import '@/components/base/input/InputSuggestion.js'
import '@/components/base/select/Select'

import _ from 'lodash'

export default {
  name: 'freeboard-comments',
  props: ['data'],

  computed: {
    ...mapGetters('freeBoard', ['boards', 'count', 'comments']),
    ...mapState('test-user', { testUsers: 'users' }),
    ...mapState('user', ['users']),
    ...mapState('freeboard-details', ['latestId'])
  },

  components: {
    TextArea

  },

  data () {
    return {
      comment: '',
      postAs: 'user',
      userId: '',
      postUser: '',
      userList: [],
      editComments: []
    }
  },

  async created () {
    await this.getComments(this.data)
  },

  watch: {
    userId (e) {
      if (!e || !this.userList.length) return
      this.postUser = (this.userList.find((u) => {
        return u.id === e
      })).login_id
    }
  },

  methods: {
    ...mapActions('freeBoard', [
      'get',
      'create',
      'update',
      'delete',
      'getCount',
      'createComment',
      'getComments',
      'deleteComment',
      'updateComment'
    ]),
    ...mapActions('test-user', { getTestUsers: 'get' }),
    ...mapActions('user', { findUser: 'find', getUsers: 'get' }),

    async searchUsers (q) {
      let params = { status: 'c', limit: 200 }

      if (q) {
        params.filter_by = 'login_id'
        params.q = q
      }
      if (this.postAs === 'test') {
        await this.getTestUsers({ status: 'c', params })
        this.userList = this.testUsers
      } else {
        await this.getUsers({ status: 'c', params })
        this.userList = this.users
      }
    },

    async addComment () {
      this.editComments.push({
        user_id: this.userId,
        content: this.comment
      })

      if (this.data.id) {
        await this.createComment({ id: this.data.id, comments: this.editComments })
      } else {
        await this.createComment({ id: this.latestId, comments: this.editComments })
      }
      await this.getComments(this.data)
      this.reset()
    },

    reset () {
      this.editComments = []
      this.comment = ''
      this.userId = ''
      this.postAs = 'user'
    }
  }
}
</script>
